// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import vueVimeoPlayer from "vue-vimeo-player";
import carousel from "v-owl-carousel";
import VueProgressBar from "vue-progressbar";
import axios from "axios";
import VueSession from "vue-session";
import VueCryptojs from "vue-cryptojs";

// css and scss files include
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "./assets/css/font-awesome.min.css";
import "./assets/index.scss";
import VeeValidate, { Validator } from "vee-validate";
import VueSimpleAlert from "vue-simple-alert";

import Notifications from "vue-notification";
import VModal from "vue-js-modal";
import Paginate from "vuejs-paginate";
import VueMoment from "vue-moment";

import SystemLanguage from "./assets/language/system.json";

// remove below file for change color
// import './assets/css/color/color-2.css'
Vue.prototype.$http = axios;

if (process.env.NODE_ENV == "development") {
  Vue.prototype.$url = "http://localhost:40401";
  // Vue.prototype.$url = 'http://121.157.229.68' //ndotcloud-alpha로 테스트
} else {
  Vue.prototype.$url = "https://api.ndotcad.com"; //aws
}

Vue.use(VueMoment);
Vue.component("paginate", Paginate);
Vue.use(VueSimpleAlert);
Vue.use(BootstrapVue);
Vue.use(vueVimeoPlayer);
Vue.component("carousel", carousel);
Vue.config.productionTip = false;

Vue.use(VeeValidate);

Vue.use(Notifications);
Vue.use(VModal, { dialog: true });

const options = {
  color: "#7DEADF",
  failedColor: "#7DEADF",
  thickness: "4px",
  transition: {
    speed: "0.5s",
    opacity: "0.10s",
    termination: 300
  },
  autoRevert: true,
  location: "top",
  inverse: false
};

Vue.use(VueProgressBar, options);
Vue.use(VueSession, { persist: true });
Vue.use(VueCryptojs);

const EventBus = new Vue({
  beforeCreate() {},
  created() {
    this.loadSystemLanguage(SystemLanguage);

    var lang = "undefined";
    lang = new URLSearchParams(location.search).get("lang");
    console.log("lang", lang);

    if (lang) {
      if (lang == "ko") {
        this.changeKorean();
      } else {
        this.changeEnglish();
      }
      return;
    }

    if (navigator.language != null) {
      lang = navigator.language;
    }
    lang = lang.toLowerCase().substring(0, 2);
    var clanguage = getCookie("ndotcad_language");

    if (!clanguage) {
      if (lang == "ko") {
        this.changeKorean();
      } else {
        this.changeEnglish();
      }
    }
  },
  methods: {
    loadSystemLanguage(jsonFile) {
      if (this.systemLanguageValue == undefined) {
        this.systemLanguageValue = new Map();
      } else {
        this.systemLanguageValue.clear();
      }
      for (const data of jsonFile) {
        this.systemLanguageValue.set(data.Key, data.Value);
      }
    },
    getSystemText(key1) {
      if (this.systemLanguageValue == undefined) {
        return "";
      }
      let value = this.systemLanguageValue.get(key1);
      if (value == undefined) {
        return "";
      }
      return value[this.language];
    },
    loadLanguage(jsonFile) {
      if (this.languageValue == undefined) {
        this.languageValue = new Map();
      } else {
        this.languageValue.clear();
      }
      for (const data of jsonFile) {
        this.languageValue.set(data.Key, data.Value);
      }
    },
    getText(key1) {
      if (this.languageValue == undefined) {
        return "";
      }
      let value = this.languageValue.get(key1);
      if (value == undefined) {
        return "";
      }
      return value[this.language];
    },
    changeKorean() {
      this.languageKey2 = "Korean";
      setCookie("ndotcad_language", this.languageKey2, 999999);
    },
    changeEnglish() {
      this.languageKey2 = "English";
      setCookie("ndotcad_language", this.languageKey2, 999999);
    },
    changeLanguage(language) {
      if (language == "English") {
        this.languageKey2 = "English";
        setCookie("ndotcad_language", this.languageKey2, 999999);
      } else {
        this.languageKey2 = "Korean";
        setCookie("ndotcad_language", this.languageKey2, 999999);
      }
    },
    isKorean() {
      if (this.language == undefined) {
        return false;
      } else if (this.language != "Korean") {
        return false;
      }
      return true;
    },
    isEnglish() {
      if (this.language == undefined) {
        return false;
      } else if (this.language != "English") {
        return false;
      }
      return true;
    }
  },
  data() {
    return {
      languageKey2: undefined,
      languageValue: undefined,
      systemLanguageValue: undefined
    };
  },
  computed: {
    language: {
      // getter
      get: function() {
        if (this.languageKey2 == undefined) {
          var clanguage = getCookie("ndotcad_language");
          if (clanguage == undefined || clanguage == "") {
            return undefined;
          } else {
            this.languageKey2 = clanguage;
          }
        }
        return this.languageKey2;
      }
    }
  }
});

Vue.prototype.EventBus = EventBus;

export const vues = new Vue();
/* eslint-disable no-new */
new Vue({
  created() {},
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js